import styled from 'styled-components';
export { ErrorSpan } from '../ErrorMessage';

export const ErrorDiv = styled.div`
  margin-top: 3px;
  height: 1.5em;
`;
